import { Modal } from '@/components/ui'
import React from 'react'

interface LessonModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export function LessonModal({ open, onOpenChange, children }: LessonModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
    >
      {children}
    </Modal>
  )
}

